import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const EmptyPinsIllustration = ({ className }) => (
  <svg className={className} fill="none" height="122" width="187">
    <path
      d="M134 122C153.882 122 170 120.657 170 119C170 117.343 153.882 116 134 116C114.118 116 98 117.343 98 119C98 120.657 114.118 122 134 122Z"
      fill="#2CB4FF"
      fillOpacity="0.2"
    />
    <rect
      x="82"
      y="27"
      width="104"
      height="74"
      rx="6"
      fill="#F4FBFF"
      stroke="#5C5CFF"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M82 89H186V95C186 98.3137 183.314 101 180 101H88C84.6863 101 82 98.3137 82 95V89Z"
      fill="white"
      stroke="#5C5CFF"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="82" y="89.5" width="104" height="2" fill="#D7D7FF" />
    <path d="M82 33C82 29.6863 84.6863 27 88 27H145L82 89V33Z" fill="white" />
    <path
      d="M143 113H125L126.535 101H141.605L143 113Z"
      fill="white"
      stroke="#5C5CFF"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M154 119H114C114 115.651 116.714 113 120.143 113H147.857C151.286 113 154 115.791 154 119Z"
      fill="white"
      stroke="#5C5CFF"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M127 101.5H141.2L141.4 103.5H126.75L127 101.5Z" fill="#D7D7FF" />
    <path
      d="M133.835 96.4721C134.516 96.4721 135.069 95.9187 135.069 95.2361C135.069 94.5534 134.516 94 133.835 94C133.153 94 132.601 94.5534 132.601 95.2361C132.601 95.9187 133.153 96.4721 133.835 96.4721Z"
      fill="#2CB4FF"
      fillOpacity="0.2"
      stroke="#5C5CFF"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="82"
      y="27"
      width="104"
      height="74"
      rx="6"
      stroke="#5C5CFF"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M164.913 73H102.253C101.501 73 101 71.85 101 70.125V52.875C101 51.15 101.501 50 102.253 50H164.913C165.665 50 166.167 51.15 166.167 52.875V70.125C166.167 71.85 165.665 73 164.913 73Z"
      fill="#EEEEFF"
      stroke="#5C5CFF"
      strokeMiterlimit="10"
    />
    <path
      d="M123.834 61.34C124.241 61.4533 124.557 61.66 124.784 61.96C125.011 62.2533 125.124 62.62 125.124 63.06C125.124 63.68 124.917 64.16 124.504 64.5C124.091 64.8333 123.507 65 122.754 65H119.794V57.88H122.654C123.381 57.88 123.944 58.0433 124.344 58.37C124.751 58.69 124.954 59.1467 124.954 59.74C124.954 60.12 124.854 60.45 124.654 60.73C124.461 61.0033 124.187 61.2067 123.834 61.34ZM120.604 61.04H122.524C123.057 61.04 123.461 60.9333 123.734 60.72C124.007 60.5067 124.144 60.1933 124.144 59.78C124.144 58.9667 123.604 58.56 122.524 58.56H120.604V61.04ZM122.684 64.32C123.244 64.32 123.654 64.2167 123.914 64.01C124.181 63.7967 124.314 63.4733 124.314 63.04C124.314 62.1667 123.771 61.73 122.684 61.73H120.604V64.32H122.684ZM130.711 59.97V65H129.921V64.13C129.761 64.4367 129.537 64.67 129.251 64.83C128.964 64.99 128.641 65.07 128.281 65.07C127.687 65.07 127.237 64.9033 126.931 64.57C126.624 64.2367 126.471 63.7433 126.471 63.09V59.97H127.281V63.07C127.281 63.5233 127.374 63.8567 127.561 64.07C127.747 64.2833 128.031 64.39 128.411 64.39C128.857 64.39 129.217 64.2467 129.491 63.96C129.764 63.6667 129.901 63.2833 129.901 62.81V59.97H130.711ZM133.352 60.61V63.36C133.352 63.7333 133.429 63.9967 133.582 64.15C133.736 64.2967 133.952 64.37 134.232 64.37C134.419 64.37 134.599 64.34 134.772 64.28V64.97C134.566 65.0367 134.332 65.07 134.072 65.07C133.592 65.07 133.216 64.9367 132.942 64.67C132.676 64.3967 132.542 63.9967 132.542 63.47V60.61H131.562V59.97H132.542V58.68L133.352 58.39V59.97H134.792V60.61H133.352ZM136.878 60.61V63.36C136.878 63.7333 136.954 63.9967 137.108 64.15C137.261 64.2967 137.478 64.37 137.758 64.37C137.944 64.37 138.124 64.34 138.298 64.28V64.97C138.091 65.0367 137.858 65.07 137.598 65.07C137.118 65.07 136.741 64.9367 136.468 64.67C136.201 64.3967 136.068 63.9967 136.068 63.47V60.61H135.088V59.97H136.068V58.68L136.878 58.39V59.97H138.318V60.61H136.878ZM141.374 65.07C140.9 65.07 140.484 64.9633 140.124 64.75C139.764 64.5367 139.484 64.2333 139.284 63.84C139.09 63.4467 138.994 62.9867 138.994 62.46C138.994 61.9333 139.09 61.4733 139.284 61.08C139.484 60.6867 139.764 60.3833 140.124 60.17C140.484 59.9567 140.9 59.85 141.374 59.85C141.847 59.85 142.264 59.9567 142.624 60.17C142.984 60.3833 143.26 60.6867 143.454 61.08C143.654 61.4733 143.754 61.9333 143.754 62.46C143.754 62.9867 143.654 63.4467 143.454 63.84C143.26 64.2333 142.984 64.5367 142.624 64.75C142.264 64.9633 141.847 65.07 141.374 65.07ZM141.374 64.4C141.874 64.4 142.257 64.2367 142.524 63.91C142.79 63.5767 142.924 63.0933 142.924 62.46C142.924 61.8467 142.787 61.3733 142.514 61.04C142.24 60.7 141.86 60.53 141.374 60.53C140.88 60.53 140.497 60.7 140.224 61.04C139.95 61.3733 139.814 61.8467 139.814 62.46C139.814 63.0933 139.947 63.5767 140.214 63.91C140.487 64.2367 140.874 64.4 141.374 64.4ZM147.526 59.85C148.733 59.85 149.336 60.5133 149.336 61.84V65H148.526V61.88C148.526 61.4133 148.433 61.0733 148.246 60.86C148.06 60.64 147.766 60.53 147.366 60.53C146.9 60.53 146.526 60.6733 146.246 60.96C145.966 61.2467 145.826 61.6333 145.826 62.12V65H145.016V61.38C145.016 60.86 144.99 60.39 144.936 59.97H145.706L145.786 60.87C145.94 60.5433 146.17 60.2933 146.476 60.12C146.783 59.94 147.133 59.85 147.526 59.85Z"
      fill="#5C5CFF"
    />
    <path
      d="M45.2947 95.5894C53.7417 95.5894 60.5894 88.7417 60.5894 80.2947C60.5894 71.8477 53.7417 65 45.2947 65C36.8477 65 30 71.8477 30 80.2947C30 88.7417 36.8477 95.5894 45.2947 95.5894Z"
      fill="#5C5CFF"
    />
    <path
      d="M45.2947 95.5894C53.7417 95.5894 60.5894 88.7417 60.5894 80.2947C60.5894 71.8477 53.7417 65 45.2947 65C36.8477 65 30 71.8477 30 80.2947C30 88.7417 36.8477 95.5894 45.2947 95.5894Z"
      stroke="#5C5CFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M46.9625 89.9479H44.1596C43.8034 89.9479 43.4618 89.8064 43.21 89.5545C42.9581 89.3027 42.8167 88.9611 42.8167 88.605V78.5287C42.8167 78.3925 42.8435 78.2578 42.8955 78.132C42.9476 78.0063 43.024 77.892 43.1202 77.7958C43.2165 77.6995 43.3307 77.6232 43.4565 77.5711C43.5822 77.519 43.717 77.4922 43.8531 77.4922H46.9625C47.2367 77.4945 47.499 77.6045 47.6928 77.7984C47.8867 77.9922 47.9967 78.2545 47.999 78.5287V88.8934C48.0014 89.031 47.9764 89.1677 47.9253 89.2956C47.8743 89.4234 47.7984 89.5398 47.7019 89.638C47.6054 89.7361 47.4903 89.8141 47.3634 89.8673C47.2364 89.9205 47.1002 89.9479 46.9625 89.9479Z"
      fill="white"
    />
    <path
      d="M45.4033 75.437C46.8319 75.437 47.99 74.2789 47.99 72.8503C47.99 71.4218 46.8319 70.2637 45.4033 70.2637C43.9747 70.2637 42.8167 71.4218 42.8167 72.8503C42.8167 74.2789 43.9747 75.437 45.4033 75.437Z"
      fill="white"
    />
    <path
      d="M2.65125 97.2792C0.579421 96.7164 0.391074 95.5909 2.46291 94.653L34.4821 81.3344C36.554 80.3964 37.4957 81.522 36.7423 83.5854L23.3696 115.475C22.4278 117.539 21.2977 117.539 20.7327 115.288L17.9075 105.158C17.3424 103.094 15.0822 100.843 13.0104 100.281L2.65125 97.2792Z"
      fill="url(#paint0_linear_3389:53184)"
      stroke="#5C5CFF"
      strokeMiterlimit="10"
    />
    <path
      d="M22.5 6C22.5 2.96243 24.9624 0.5 28 0.5H114C117.038 0.5 119.5 2.96243 119.5 6V47C119.5 50.0376 117.038 52.5 114 52.5H57.4853C55.7614 52.5 54.1081 53.1848 52.8891 54.4038L47.7112 59.5817C46.7535 60.5394 45.2073 60.5603 44.2241 59.6288L38.5795 54.2813C37.3722 53.1375 35.7723 52.5 34.1092 52.5H28C24.9624 52.5 22.5 50.0376 22.5 47V6Z"
      fill="white"
      stroke="#5C5CFF"
    />
    <rect x="34" y="12" width="74" height="12" rx="6" fill="#EEEEFF" />
    <rect x="34" y="30" width="74" height="12" rx="6" fill="#EEEEFF" />
    <defs>
      <linearGradient
        id="paint0_linear_3389:53184"
        x1="19"
        y1="81"
        x2="19"
        y2="117"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF5290" />
        <stop offset="0.0001" stopColor="#FF5290" />
        <stop offset="1" stopColor="#8960FF" />
      </linearGradient>
    </defs>
  </svg>
);

EmptyPinsIllustration.propTypes = {
  className: PropTypes.string,
};

export default styled(EmptyPinsIllustration)``;
